import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminNotify(props) {
    const formnotifyRef = useRef(null)
    const line_urlRef = useRef(null)
    const line_tokenRef = useRef(null)

    const email_serviceRef = useRef(null)
    const email_portRef = useRef(null)
    const email_subjectRef = useRef(null)
    const email_senderRef = useRef(null)
    const email_recieverRef = useRef(null)
    const email_usernameRef = useRef(null)
    const email_passwordRef = useRef(null)

    const [notifyitem, setNotifyitem] = useState({
        id: 0,
        line_enable: false,
        line_url: '',
        line_token: '',
        email_enable: false,
        email_service: '',
        email_port: 0,
        email_subject: '',
        email_sender: '',
        email_reciever: '',
        email_username: '',
        email_password: '',
        edittime: ''
    });
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    useEffect(() => {
        if (notifyitem.line_enable === false) {
            line_urlRef.current.disabled = true
            line_tokenRef.current.disabled = true
        } else {
            line_urlRef.current.disabled = false
            line_tokenRef.current.disabled = false
        }
    }, [notifyitem.line_enable]);

    useEffect(() => {
        if (notifyitem.email_enable === false) {
            email_serviceRef.current.disabled = true
            email_portRef.current.disabled = true
            email_subjectRef.current.disabled = true
            email_senderRef.current.disabled = true
            email_recieverRef.current.disabled = true

            email_usernameRef.current.disabled = true
            email_passwordRef.current.disabled = true
        } else {
            email_serviceRef.current.disabled = false
            email_portRef.current.disabled = false
            email_subjectRef.current.disabled = false
            email_senderRef.current.disabled = false
            email_recieverRef.current.disabled = false

            email_usernameRef.current.disabled = false
            email_passwordRef.current.disabled = false
        }
    }, [notifyitem.email_enable]);

    useEffect(() => {
        api_get_list()
        return () => {
            setNotifyitem({})
        };
    }, []);

    async function api_get_list() {
        setmodal_load({ enable: true, message: "Loading alarm notify." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/notify/getdata", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setNotifyitem(response.data.notify)
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_save_data() {
        var formelement = formnotifyRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            setmodal_load({ enable: true, message: "Saving alarm notify." })
            await sleep(500)

            formelement.classList.remove("was-validated");
            const formData = new FormData();
            formData.append('line_enable', notifyitem.line_enable)
            formData.append('line_url', notifyitem.line_url)
            formData.append('line_token', notifyitem.line_token)
            formData.append('email_enable', notifyitem.email_enable)
            formData.append('email_service', notifyitem.email_service)
            formData.append('email_port', notifyitem.email_port)
            formData.append('email_subject', notifyitem.email_subject)
            formData.append('email_sender', notifyitem.email_sender)
            formData.append('email_reciever', notifyitem.email_reciever)
            formData.append('email_username', notifyitem.email_username)
            formData.append('email_password', notifyitem.email_password)

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/notify/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your alarm notify has been saved to database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        })
                    }
                    if (response.data.notify !== undefined) {
                        setNotifyitem(response.data.notify)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    })
                });
        }
    }

    async function api_reboot() {
        setmodal_load({ enable: true, message: "Rebooting application....." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/app/reboot", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your application has been recieved reboot command.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-sms"></i> Alarm Notify</h4>
                                    <p className="mb-3">Manage your alarm notify connection</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" type="button" onClick={() => { api_get_list() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_reboot() }}><i className="fas fa-power-off"></i> Reboot Service</button>
                            </div>
                        </div>
                    </div>

                    <form ref={formnotifyRef} className='mt-3 mb-1 mb-md-4' action="" method="POST" encType="multipart/form-data" >
                        <div className="row mb-1">
                            <h6>Line Notify Connection</h6>
                            <div className="col-md-8 col-xl-6">
                                <div className="form-check mb-3">
                                    <input name="line_enable" className="form-check-input" type="checkbox" checked={notifyitem.line_enable} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            line_enable: e.target.checked
                                        })
                                    }} />
                                    <label htmlFor="line_enable" className="form-check-label">
                                        Enable Line Notify.
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-xl-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="line_url">Line Notify URL</label>
                                    <input type="text" className="form-control" ref={line_urlRef} name="line_url" value={notifyitem.line_url} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            line_url: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-xl-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="line_token">Line Notify Token (Bearer)</label>
                                    <input type="text" className="form-control" ref={line_tokenRef} name="line_token" value={notifyitem.line_token} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            line_token: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <h6>Email Notify Connection</h6>
                            <div className="col-md-4 col-xl-3">
                                <div className="form-check mb-3">
                                    <input name="email_enable" className="form-check-input" type="checkbox" checked={notifyitem.email_enable} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            email_enable: e.target.checked
                                        })
                                    }} />
                                    <label htmlFor="email_enable" className="form-check-label">
                                        Enable Email Notify.
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-xl-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="email_service">SMTP Host Name</label>
                                    <input type="text" className="form-control" ref={email_serviceRef} name="email_service" value={notifyitem.email_service} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            email_service: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="email_port">SMTP Port</label>
                                    <input type="number" className="form-control" ref={email_portRef} name="email_port" min={1} max={65535} value={notifyitem.email_port} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            email_port: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-xl-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="email_subject">Email Subject</label>
                                    <input type="text" className="form-control" ref={email_subjectRef} name="email_subject" value={notifyitem.email_subject} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            email_subject: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-xl-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="email_sender">Email From (Sender)</label>
                                    <input type="text" className="form-control" ref={email_senderRef} name="email_sender" value={notifyitem.email_sender} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            email_sender: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-xl-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="email_username">Authentication Username</label>
                                    <input type="text" className="form-control" ref={email_usernameRef} name="email_username" value={notifyitem.email_username} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            email_username: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                            <div className="col-md-4 col-xl-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="email_password">Authentication Password</label>
                                    <input type="text" className="form-control" ref={email_passwordRef} name="email_password" value={notifyitem.email_password} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            email_password: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-xl-6">
                                <div className="form-group mb-3">
                                    <label htmlFor="email_reciever">Email Reciever</label>
                                    <input type="text" className="form-control" ref={email_recieverRef} name="email_reciever" value={notifyitem.email_reciever} onChange={(e) => {
                                        setNotifyitem({
                                            ...notifyitem,
                                            email_reciever: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-8 col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="edittime">Edit Time</label>
                                    <input type="text" className="form-control" name="edittime" value={notifyitem.edittime} readOnly />
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="row">
                        <div className="col-md-3 mb-1 mt-3">
                            <button className="btn btn-warning btn-sm" type="button" onClick={() => { api_save_data() }}><i className="fe-save"></i> Save</button>
                        </div>
                    </div>
                    <hr className="new-section-xs" />
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminNotify